export const money = (value, currency = 'USD') => {
  if (typeof value !== 'number' || !Number.isFinite(value)) return '--';
  try {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(value);
  } catch {
    return `${currency} ${value.toFixed(2)}`;
  }
};

// Statement dates use Eastern time because that is the backend's accounting-day boundary.
export function easternToday(now = new Date(Date.now())) {
  try {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).formatToParts(now);
    const get = (type) => parts.find((part) => part.type === type)?.value ?? '';
    const date = `${get('year')}-${get('month')}-${get('day')}`;
    return /^\d{4}-\d{2}-\d{2}$/.test(date) ? date : null;
  } catch {
    return null;
  }
}

export function whenLabel(iso, timeZone, locale = 'en-US') {
  if (!iso) return null;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  try {
    return new Intl.DateTimeFormat(locale, {
      timeZone: timeZone || 'America/Chicago',
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      timeZoneName: 'short',
    }).format(date);
  } catch {
    return date.toISOString().replace('T', ' ').slice(0, 16) + ' UTC';
  }
}

export const stampLabel = (iso) => {
  if (!iso) return '--';
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? '--' : date.toLocaleString();
};

// Advance the server timestamp by real elapsed time so browser clock skew cannot create staleness.
export function serverNow(generatedAt, receivedAt, now = Date.now()) {
  const generated = Date.parse(generatedAt || '');
  if (Number.isNaN(generated) || !receivedAt) return new Date(now);
  return new Date(generated + (now - receivedAt));
}
